import { Box, Grid, Skeleton } from '@mui/material';

const Loader: React.FC = () => {
    return (
        <Box sx={{ p: 3 }}>
            {/* Calendar Grid Skeleton */}
            <Grid container spacing={2}>
                {[...Array(6)].map((_, monthIndex) => (
                    <Grid item xs={12} sm={6} md={4} key={monthIndex}>
                        <Box sx={{ p: 2, border: '1px solid #e0e0e0', borderRadius: '8px' }}>
                            {/* Month Header */}
                            <Skeleton variant="text" width={120} height={32} sx={{ mb: 2 }} />

                            {/* Weekday Headers */}
                            <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(7, 1fr)', gap: 0.5, mb: 1 }}>
                                {[...Array(7)].map((_, dayIndex) => (
                                    <Skeleton key={dayIndex} variant="text" width={24} height={20} />
                                ))}
                            </Box>

                            {/* Calendar Days */}
                            <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(7, 1fr)', gap: 0.5 }}>
                                {[...Array(35)].map((_, dayIndex) => (
                                    <Skeleton
                                        key={dayIndex}
                                        variant="rectangular"
                                        width={32}
                                        height={32}
                                        sx={{ borderRadius: '4px' }}
                                    />
                                ))}
                            </Box>
                        </Box>
                    </Grid>
                ))}
            </Grid>

            {/* Controls Section Skeleton */}
            <Box sx={{ mt: 4, p: 2, border: '1px solid #e0e0e0', borderRadius: '8px', display: 'flex', gap: 2 }}>
                <Skeleton variant="text" width={200} height={32} sx={{ mb: 2 }} />
                <Box sx={{ display: 'flex', gap: 2 }}>
                    <Skeleton variant="rectangular" width={150} height={40} sx={{ borderRadius: '4px' }} />
                    <Skeleton variant="rectangular" width={150} height={40} sx={{ borderRadius: '4px' }} />
                </Box>
                <Box sx={{ display: 'flex', gap: 2 }}>
                    <Skeleton variant="rectangular" width={120} height={36} sx={{ borderRadius: '4px' }} />
                    <Skeleton variant="rectangular" width={120} height={36} sx={{ borderRadius: '4px' }} />
                </Box>
            </Box>
        </Box>
    );
};

export default Loader;
